<template>
    <div id="deliverydateoverviewpage">
        <div
            class="delivery-date-admin"
            v-if="hasRight('administration')"
        >
            <ui5-button @click="$router.push('/deliveryroutes')">
                {{ trans('pages.delivery_date_overview.to_rounds') }}
            </ui5-button>
            <ui5-button
                v-if="orderId"
                @click="$router.push('/editproduct')"
            >
                {{ trans('pages.delivery_date_overview.to_last_opened_order') }}
            </ui5-button>
            <ui5-button
                id="addDeliveryDateButton2"
                @click="$router.push('/adddeliverydate')"
            >
                {{ trans('pages.delivery_date_overview.add_ride') }}
            </ui5-button>
        </div>
        <div class="sorting">
            <ui5-label>
                {{ trans('pages.delivery_date_overview.sorting') }}
            </ui5-label>

            <ui5-select
                @change="
                    filters.deliverdatesortOrder =
                        $event.detail.selectedOption.value
                "
            >
                <ui5-option
                    v-for="option in sortOrderOptions"
                    :key="option.value"
                    :selected="option.value == filters.deliverdatesortOrder"
                    :value="option.value"
                >
                    {{ option.label }}
                </ui5-option>
            </ui5-select>

            <ui5-select
                @change="
                    filters.deliverdatespecialFilter =
                        $event.detail.selectedOption.value
                "
            >
                <ui5-option
                    v-for="option in specialFilterOptions"
                    :key="option.value"
                    :selected="option.value == filters.deliverdatespecialFilter"
                    :value="option.value"
                >
                    {{ option.label }}
                </ui5-option>
            </ui5-select>
        </div>

        <div class="productoverviewline">
            <div
                class="iconcolumn"
                v-if="hasRight('administration')"
            />
            <div class="iconcolumn" />
            <div
                class="iconcolumn"
                v-if="hasRight('administration')"
            />
            <div class="iconcolumn" />
            <div class="deliverydateoverviewcolumn">
                <ui5-input
                    :placeholder="
                        trans('pages.delivery_date_overview.ride_number')
                    "
                    @keyup.enter="applyFilters"
                    :value="filters.deliverdatenr"
                    @input="filters.deliverdatenr = $event.target.value"
                />
            </div>
            <div class="deliverydateoverviewcolumn">
                <ui5-select
                    @change="
                        filters.deliverdaterecurring =
                            $event.detail.selectedOption.value
                    "
                >
                    <ui5-option
                        v-for="option in deliverdateRecurringOptions"
                        :key="option.value"
                        :selected="option.value == filters.deliverdaterecurring"
                        :value="option.value"
                    >
                        {{ option.label }}
                    </ui5-option>
                </ui5-select>
            </div>
            <div class="deliverydateoverviewcolumn">
                <ui5-select
                    @change="
                        filters.deliverdateToBePlanned =
                            $event.detail.selectedOption.value
                    "
                >
                    <ui5-option
                        v-for="option in deliverdateToBePlannedOptions"
                        :key="option.value"
                        :selected="
                            option.value == filters.deliverdateToBePlanned
                        "
                        :value="option.value"
                    >
                        {{ option.label }}
                    </ui5-option>
                </ui5-select>
            </div>
            <div class="deliverydateoverviewcolumn">
                <ui5-date-picker
                    @click="$event.target.openPicker()"
                    :value="filters.deliverdatedate"
                    @change="filters.deliverdatedate = $event.detail.value"
                    @keyup.enter="applyFilters"
                    format-pattern="yyyy-MM-dd"
                />
            </div>
            <div class="deliverydateoverviewcolumn">
                <ui5-select
                    @change="
                        filters.deliverdatedriver =
                            $event.detail.selectedOption.value
                    "
                >
                    <ui5-option
                        v-for="option in driverOptions"
                        :key="option.value"
                        :selected="option.value == filters.deliverdatedriver"
                        :value="option.value"
                    >
                        {{ option.label }}
                    </ui5-option>
                </ui5-select>
            </div>
            <div class="deliverydateoverviewcolumn">
                <ui5-select
                    @change="
                        filters.deliverdatetruck =
                            $event.detail.selectedOption.value
                    "
                >
                    <ui5-option
                        v-for="option in truckOptions"
                        :key="option.value"
                        :selected="option.value == filters.deliverdatetruck"
                        :value="option.value"
                    >
                        {{ option.label }}
                    </ui5-option>
                </ui5-select>
            </div>
            <div class="deliverydateoverviewcolumn">
                <ui5-select
                    @change="
                        filters.deliverdatedeliverymethod =
                            $event.detail.selectedOption.value
                    "
                >
                    <ui5-option
                        v-for="option in deliveryMethodOptions"
                        :key="option.value"
                        :selected="
                            option.value == filters.deliverdatedeliverymethod
                        "
                        :value="option.value"
                    >
                        {{ option.label }}
                    </ui5-option>
                </ui5-select>
            </div>
            <div class="deliverydateoverviewcolumn">
                <ui5-input
                    :placeholder="trans('pages.delivery_date_overview.region')"
                    @keyup.enter="applyFilters"
                    :value="filters.deliverdateregion"
                    @input="filters.deliverdateregion = $event.target.value"
                />
            </div>
            <div class="deliverydateoverviewcolumn">
                <ui5-input
                    id="deliverdatetype"
                    :placeholder="trans('pages.delivery_date_overview.type')"
                    @keyup.enter="applyFilters"
                    :value="filters.deliverdatetype"
                    @input="filters.deliverdatetype = $event.target.value"
                />
            </div>
            <div class="deliverydateoverviewcolumn">
                <ui5-input
                    id="deliverdatefull"
                    :placeholder="trans('pages.delivery_date_overview.full')"
                    @keyup.enter="applyFilters"
                    :value="filters.deliverdatefull"
                    @input="filters.deliverdatefull = $event.target.value"
                />
            </div>
            <div class="deliverydateoverviewcolumn deliverydate-text-column">
                {{ trans('pages.delivery_date_overview.invoiced') }}
            </div>
            <div class="deliveryoverviewgoto">
                <i
                    @click="applyFilters"
                    class="fa fa-filter fa-2x"
                />
            </div>
            <div class="deliveryoverviewgoto">
                <i
                    @click="clearFiltersAndLoad"
                    class="fa fa-ban fa-2x"
                />
            </div>
        </div>
        <template v-if="deliveryDates">
            <div
                v-for="(deliveryDate, deliveryDateIndex) in deliveryDates"
                :key="deliveryDate.id"
                class="productoverviewline"
                :style="{ backgroundColor: getColor(deliveryDate) }"
            >
                    <template v-if="hasRight('administration')">
                        <div class="iconcolumn">
                            <i
                                class="fa fa-pencil"
                                @click="prepareUpdateDateForm(deliveryDate.id)"
                            ></i>
                        </div>
                        <div class="iconcolumn">
                            <i
                                class="fa fa-info-circle"
                                @click="
                                    prepareDetailDateForm(
                                        deliveryDate.id,
                                        deliveryDateIndex
                                    )
                                "
                            ></i>
                        </div>
                        <div class="iconcolumn">
                            <i
                                @click="
                                    deleteDeliveryDate(
                                        deliveryDate.id,
                                        deliveryDateIndex
                                    )
                                "
                                class="fa fa-trash"
                            ></i>
                        </div>
                        <div class="iconcolumn">
                            <i
                                class="fa fa-print"
                                @click="exportDeliveryDate(deliveryDate.id)"
                            ></i>
                        </div>
                    </template>
                    <template v-else>
                        <div class="iconcolumn">
                            <i
                                class="fa fa-info-circle"
                                @click="
                                    prepareDetailDateForm(
                                        deliveryDate.id,
                                        deliveryDateIndex
                                    )
                                "
                            ></i>
                        </div>
                        <div class="iconcolumn">
                            <i
                                class="fa fa-print"
                                @click="exportDeliveryDate(deliveryDate.id)"
                            ></i>
                        </div>
                    </template>
                    <div class="deliverydateoverviewcolumn">
                        <ui5-input
                            type="Text"
                            class="productoverviewinput1"
                            :value="deliveryDate.key"
                            readonly
                        />
                    </div>
                    <div class="deliverydateoverviewcolumn">
                        <ui5-input
                            type="Text"
                            class="productoverviewinput8"
                            :value="
                                trans(
                                    deliveryDate.recurringConfigId
                                        ? 'pages.delivery_date_overview.recurring'
                                        : 'pages.delivery_date_overview.not_recurring'
                                )
                            "
                            readonly
                        />
                    </div>
                    <div class="deliverydateoverviewcolumn">
                        <ui5-input
                            type="Text"
                            class="productoverviewinput8"
                            :value="
                                deliveryDate.toBePlanned == '1'
                                    ? trans(
                                          'pages.delivery_date_overview.not_planned'
                                      )
                                    : trans(
                                          'pages.delivery_date_overview.planned'
                                      )
                            "
                            readonly
                        />
                    </div>
                    <div class="deliverydateoverviewcolumn">
                        <ui5-input
                            type="Text"
                            class="productoverviewinput2"
                            :value="
                                capitalizeFirstLetter(formatDate(deliveryDate))
                            "
                            readonly
                        />
                    </div>
                    <div class="deliverydateoverviewcolumn">
                        <ui5-input
                            type="Text"
                            class="productoverviewinput3"
                            :value="
                                deliveryDate.driverDetails
                                    ? deliveryDate.driverDetails.name
                                    : ''
                            "
                            readonly
                        />
                    </div>
                    <div class="deliverydateoverviewcolumn">
                        <ui5-input
                            type="Text"
                            class="productoverviewinput4"
                            :value="
                                deliveryDate.truckDetails
                                    ? deliveryDate.truckDetails.name
                                    : ''
                            "
                            readonly
                        />
                    </div>
                    <div class="deliverydateoverviewcolumn">
                        <ui5-input
                            type="Text"
                            class="productoverviewinput4"
                            :value="
                                deliveryDate.deliveryMethodDetails
                                    ? deliveryDate.deliveryMethodDetails.name
                                    : ''
                            "
                            readonly
                        />
                    </div>
                    <div class="deliverydateoverviewcolumn">
                        <ui5-input
                            type="Text"
                            class="productoverviewinput5"
                            :value="deliveryDate.description"
                            readonly
                        />
                    </div>
                    <div class="deliverydateoverviewcolumn">
                        <ui5-input
                            type="Text"
                            class="productoverviewinput6"
                            :value="deliveryDate.truck"
                            readonly
                        />
                    </div>
                    <div class="deliverydateoverviewcolumn">
                        <ui5-input
                            type="Text"
                            class="productoverviewinput7"
                            :value="
                                deliveryDate.full == 0
                                    ? trans('pages.delivery_date_overview.no')
                                    : trans('pages.delivery_date_overview.yes')
                            "
                            readonly
                        />
                    </div>
                    <div
                        class="deliverydateoverviewcolumn"
                        @change="updateInvoiced($event, deliveryDate)"
                    >
                        <ui5-switch
                            text-on="trans('pages.delivery_date_overview.yes')"
                            text-off="trans('pages.delivery_date_overview.no')"
                            :checked="deliveryDate.invoiced"
                        />
                    </div>
            </div>
        </template>
        <div
            class="spinner-container"
            v-if="loading"
        >
            <spinner class="spinner" />
        </div>
        <div
            v-else
            class="load-more"
            @click="loadMore"
        >
            {{ trans('pages.delivery_date_overview.load_more') }}
        </div>
        <div
            class="productoverviewline"
            v-if="deliveryDates"
        >
            {{
                trans('pages.delivery_date_overview.total_loaded_rides', {
                    count: deliveryDates.length,
                })
            }}
        </div>
        <recurring-delete-scope-dialog ref="deleteScopeDialog" />
        <recurring-delete-warning-dialog ref="deleteWarningDialog" />
    </div>
</template>
<script>
import {
    sortOrderOptions,
    specialFilterOptions,
    deliverdateToBePlannedOptions,
    deliverdateRecurringOptions,
    clearedFilters,
    jaNeeToBool,
} from '../shared/deliveryDates';
import api from './../api/deliveryDates';
import spinner from '../components/loader/Spinner';
import Spinner from '../components/loader/Spinner';
import RecurringDeleteScopeDialog from '../components/deliveryDates/RecurringDeleteScopeDialog';
import RecurringDeleteWarningDialog from '../components/deliveryDates/RecurringDeleteWarningDialog';
import { exportDeliveryDate } from '../shared/deliveryDates';
import { mapGetters } from 'vuex';
import { capitalizeFirstLetter } from '../helpers/StringHelpers';
import moment from 'moment';
import {
    showConfirmDialog,
    showInfoMessage,
    showErrorMessage,
} from '../dialogs';

export default {
    components: {
        Spinner,
        RecurringDeleteScopeDialog,
        RecurringDeleteWarningDialog
    },
    data() {
        return {
            loading: false,
            orderId: null,
            deliveryDates: null,
            overviewDeliveryDateLimit: 50,
            sortOrderOptions,
            specialFilterOptions,
            deliverdateToBePlannedOptions,
            deliverdateRecurringOptions,
            truckOptions: null,
            driverOptions: null,
            deliveryMethodOptions: null,
            filters: { ...clearedFilters },
        };
    },
    updated() {
        const datePickers = this.$el.querySelectorAll(
            '#deliverydateoverviewpage ui5-date-picker'
        );
        Array.from(datePickers).forEach((datePicker) => {
            const interval = window.setInterval(() => {
                if (datePicker.shadowRoot) {
                    const input =
                        datePicker.shadowRoot.querySelector('ui5-input');
                    if (input) {
                        input.style.width = '100%';
                        input.style.minWidth = '100%';
                        window.clearInterval(interval);
                    }
                }
            }, 100);
        });
    },
    computed: {
        ...mapGetters({
            hasRight: 'currentUser/hasRight',
        }),
        clickedOffset: {
            get() {
                return this.$store.getters['deliveryDates/getOffsetClicked'];
            },
            set(value) {
                this.$store.commit('deliveryDates/setOffsetClicked', value, {
                    root: true,
                });
            },
        },
    },
    methods: {
        exportDeliveryDate,
        prepareDetailDateForm(dateId, index) {
            this.clickedOffset = index;
            this.$router.push('/deliverydatedetails/' + dateId);
        },
        prepareUpdateDateForm(dateId) {
            this.$router.push('/editdeliverydate/' + dateId);
        },
        async deleteDeliveryDate(dateId, index) {
            const deliveryDate = this.deliveryDates[index];
            const isRecurring = !!deliveryDate.recurringConfigId;

            // If recurring, show scope dialog directly (no confirmation dialog)
            if (isRecurring) {
                const scope = await this.$refs.deleteScopeDialog.open();

                if (!scope) {
                    // User cancelled the scope dialog
                    return;
                }

                if (scope === 'this') {
                    // Delete only this trip
                    api.deleteDate(dateId)
                        .then(() => {
                            this.$delete(this.deliveryDates, index);
                            showInfoMessage(
                                this.trans('pages.recurring.deleted_this')
                            );
                        })
                        .catch((error) => {
                            if (error.response?.data?.error_type === 'trips_have_orders') {
                                this.$refs.deleteWarningDialog.open(error.response.data.trips);
                            } else {
                                showErrorMessage(
                                    this.trans(
                                        'pages.delivery_date_overview.delete_ride.error'
                                    )
                                );
                            }
                        });
                } else if (scope === 'this_and_following') {
                    // Delete this and following trips
                    api.deleteRecurringInstance(dateId, scope)
                        .then((response) => {
                            const deletedCount = response.data.data.deleted_count || 0;

                            // Reload the list to reflect all deleted trips
                            this.deliveryDates = null;
                            this.loadMore();
                            showInfoMessage(
                                this.trans('pages.recurring.deleted_this_and_following', {
                                    count: deletedCount
                                })
                            );
                        })
                        .catch((error) => {
                            if (error.response?.data?.error_type === 'trips_have_orders') {
                                this.$refs.deleteWarningDialog.open(error.response.data.trips);
                            } else {
                                showErrorMessage(
                                    this.trans(
                                        'pages.delivery_date_overview.delete_ride.error'
                                    )
                                );
                            }
                        });
                }
            } else {
                // Non-recurring trip - show confirmation dialog
                showConfirmDialog({
                    title: this.trans(
                        'pages.delivery_date_overview.delete_ride.title'
                    ),
                    content: this.trans(
                        'pages.delivery_date_overview.delete_ride.confirmation'
                    ),
                    confirm: () => {
                        api.deleteDate(dateId)
                            .then(() => {
                                this.$delete(this.deliveryDates, index);
                                showInfoMessage(
                                    this.trans(
                                        'pages.delivery_date_overview.delete_ride.success'
                                    )
                                );
                            })
                            .catch((error) => {
                                if (error.response?.data?.error_type === 'trips_have_orders') {
                                    this.$refs.deleteWarningDialog.open(error.response.data.trips);
                                } else {
                                    showErrorMessage(
                                        this.trans(
                                            'pages.delivery_date_overview.delete_ride.error'
                                        )
                                    );
                                }
                            });
                    },
                    closeOnCancel: true,
                    closeOnOk: true,
                    confirmButton: this.trans('pages.delivery_date_overview.yes'),
                    cancelButton: this.trans('pages.delivery_date_overview.no'),
                });
            }
        },
        clearFiltersAndLoad() {
            this.filters = { ...clearedFilters };
            this.applyFilters();
        },
        applyFilters() {
            this.$store.commit('deliveryDates/setFilters', this.filters, {
                root: true,
            });
            this.deliveryDates = null;
            this.loadMore();
        },
        updateInvoiced($event, deliveryDate) {
            api.updateInvoiced(deliveryDate.id, $event.target.checked)
                .then(() => {
                    showInfoMessage(
                        this.trans(
                            'pages.delivery_date_overview.invoice_status.success'
                        )
                    );
                })
                .catch(() => {
                    deliveryDate.invoiced = !deliveryDate.invoiced;
                    showErrorMessage(
                        this.trans(
                            'pages.delivery_date_overview.invoice_status.error'
                        )
                    );
                });
        },
        getColor(deliveryDate) {
            if (deliveryDate.statusFinished) {
                return 'rgba(0, 255, 0, 0.6)';
            } else {
                return 'rgba(255, 0, 0, 0.6)';
            }
        },
        capitalizeFirstLetter,
        formatDate(deliveryDate) {
            var date = new Date(deliveryDate.date);
            return moment(date).format('dddd DD/MM/YYYY');
        },
        getPayload() {
            return {
                ...this.filters,
                deliverdatefull: jaNeeToBool(this.filters.deliverdatefull),
                offset: this.deliveryDates ? this.deliveryDates.length : 0,
                limit: this.overviewDeliveryDateLimit,
            };
        },
        loadMore() {
            this.loading = true;
            api.fetchOverview(this.getPayload())
                .then((response) => {
                    if (this.deliveryDates) {
                        // Filter out any IDs that already exist to prevent duplicates
                        const existingIds = new Set(this.deliveryDates.map(d => d.id));
                        const newDates = response.data.data.filter(d => !existingIds.has(d.id));
                        this.deliveryDates.push(...newDates);
                    } else {
                        this.deliveryDates = response.data.data;
                    }
                })
                .finally(() => {
                    this.loading = false;
                });
        },
    },
    mounted() {
        this.orderId = this.$route.query.orderId;
        this.filters = this.$store.getters['deliveryDates/getFilters'];

        api.listTrucks().then((response) => {
            const options = [{ value: '-1', label: 'Filter' }];

            options.push(
                ...response.data.data.map((x) => {
                    return { value: x.ID, label: x.name };
                })
            );

            this.truckOptions = options;
        });

        api.listDeliveryMethods().then((response) => {
            const options = [{ value: '-1', label: 'Filter' }];

            options.push(
                ...response.data.data.map((x) => {
                    return { value: x.id, label: x.name };
                })
            );

            this.deliveryMethodOptions = options;
        });

        api.listDrivers().then((response) => {
            const options = [{ value: '-1', label: 'Filter' }];

            options.push(
                ...response.data.data.map((x) => {
                    return { value: x.ID, label: x.name };
                })
            );

            this.driverOptions = options;
        });

        this.loadMore();
    },
    beforeRouteEnter(to, from, next) {
        next(vm => {
            if (from.path === '/adddeliverydate' || from.path.startsWith('/editdeliverydate')) {
                // Reload filters from store to ensure they're up-to-date
                vm.filters = vm.$store.getters['deliveryDates/getFilters'];
                vm.deliveryDates = null;
                vm.loadMore();
            }
        });
    },
};
</script>
